import React from 'react';
import "./iam.css";
import { MdArrowForward } from 'react-icons/md';

const LiveDemosCards = ({liveDemoCards}) => {

    const handleCardClick = (link) => {
        if (link && link !== "#") {
            window.open(link, '_blank');
        }
    };

    return (
        <div className="d-flex mt-4 flex-column flex-1 flex-grow-1 overflow-y-auto overflow-x-hidden pe-4" style={{ height: "calc( 100vh - 390px)"}}>
            <div className="row g-4">
                {liveDemoCards.map((item, index) => (
                    <div key={index} className="col-sm-12 col-md-6 col-lg-6 col-xl-3 card-hover-wrapper">
                        <div 
                            className="custom-shadow d-flex flex-column border rounded-4 px-4 py-4 align-items-start h-100" 
                            onClick={() => handleCardClick(item.link)}
                            style={{ cursor: 'pointer' }}
                        >
                            <div className="w-100 mb-3">
                                <img 
                                    src={item.image} 
                                    alt={item.title} 
                                    className="w-100 rounded-3"
                                    style={{height: '200px', objectFit: 'cover'}}
                                />
                            </div>
                            <div className='d-flex flex-column w-100'>
                                <span style={{fontWeight:500, fontSize:'17px'}}>
                                    {item?.title}
                                </span>
                            </div>
                            <div className='watch-btn fw-medium mt-auto' style={{color:"#EB5424"}}>
                                Watch now <MdArrowForward />
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default LiveDemosCards;
